import { Grid, Typography, RadioGroup, Radio, TextField, Button, FormControl, FormControlLabel, FormHelperText, FormLabel } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import { useGlobalState } from "../../../context/AppContext";

interface Props {
  children?: React.ReactElement<unknown>;
  form: FormBase<Contact>
  setForm: Function
}

const texts = [
  "* 項目は必須項目です。必ずご入力いただきまして送信いただきますようお願い申し上げます。"
]

export default function ContactForm(props: Props) {
  /** グローバルステート */
  const { state } = useGlobalState()

  /** 入力処理 */
  const handleChange = (event: any) => {
    props.setForm({
      ...props.form,
      value: {
        ...props.form.value,
        [event.target.name]: event.target.value
      }
    })
  }

  return (
    <Grid container spacing={5} sx={{ padding: '1rem' }}>
      <Grid size={12}>
        {texts.map((t, index) => {
          return (
            <Typography key={index} color={"warning"} variant="body1">
              {t}
            </Typography>
          )
        })}
      </Grid>
      <Grid size={12}>
        <FormControl error={!!props.form.invalid.category}>
          <FormLabel>お問い合わせ種別</FormLabel>
          <RadioGroup
            row
            id="category"
            name="category"
            value={props.form.value.category}
            onChange={handleChange}
          >
            <FormControlLabel
              control={<Radio />}
              value="新卒採用について"
              label="新卒採用について"
            />
            <FormControlLabel
              control={<Radio />}
              value="経験者採用について"
              label="経験者採用について"
            />
            <FormControlLabel
              control={<Radio />}
              value="その他"
              label="その他"
            />
          </RadioGroup>
          <FormHelperText>{props.form.invalid.category}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 12 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="件名"
            id="subject"
            name="subject"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.subject}
            error={!!props.form.invalid.subject}
            helperText={props.form.invalid.subject}
            onChange={handleChange}
            required
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="氏名"
            id="name"
            name="name"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.name}
            error={!!props.form.invalid.name}
            helperText={props.form.invalid.name}
            onChange={handleChange}
            required
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="メールアドレス"
            id="email"
            name="email"
            type="email"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.email}
            error={!!props.form.invalid.email}
            helperText={props.form.invalid.email}
            onChange={handleChange}
            required
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="会社／学校名"
            id="company"
            name="company"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.company}
            error={!!props.form.invalid.company}
            helperText={props.form.invalid.company}
            onChange={handleChange}
            required
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="電話番号"
            id="tel"
            name="tel"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.tel}
            error={!!props.form.invalid.tel}
            helperText={props.form.invalid.tel}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="郵便番号"
            id="post"
            name="post"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.post}
            error={!!props.form.invalid.post}
            helperText={props.form.invalid.post}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 12 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            label="住所"
            id="address"
            name="address"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.address}
            error={!!props.form.invalid.address}
            helperText={props.form.invalid.address}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControl
          sx={{ width: '100%' }}
        >
          <TextField
            multiline
            rows={10}
            label="お問い合わせ内容"
            id="message"
            name="message"
            variant="outlined"
            autoComplete='on'
            value={props.form.value.message}
            error={!!props.form.invalid.message}
            helperText={props.form.invalid.message}
            onChange={handleChange}
            required
          />
        </FormControl>
      </Grid>
      <Grid size={12}>
        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={state.dialog.isOpen}
          endIcon={<SendIcon />}
        >
          お問い合わせを送信
        </Button>
      </Grid>
    </Grid>
  )
}